import { Component, OnDestroy } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { CheckboxComponent } from '@camelot/form-input';
import { InputCheckBox } from '@camelot/form-model';

@Component({
  selector: 'cam-grid-selection-checkbox',
  templateUrl: './selection-checkbox.component.html',
  styleUrl: './selection-checkbox.component.scss',
  imports: [CheckboxComponent],
})
export class SelectionCheckboxComponent implements ICellRendererAngularComp, OnDestroy {
  public input = new InputCheckBox({ key: 'grid-selection-row' });

  private _params: ICellRendererParams | null = null;
  private readonly _syncFromNode = () => {
    this.input.value = this._params?.node.isSelected() ?? false;
  };

  ngOnDestroy(): void {
    this._params?.node.removeEventListener('rowSelected', this._syncFromNode);
  }

  agInit(params: ICellRendererParams): void {
    this._params = params;
    this.input.value = params.node.isSelected() ?? false;
    params.node.addEventListener('rowSelected', this._syncFromNode);
  }

  refresh(params: ICellRendererParams): boolean {
    this._params = params;
    this._syncFromNode();
    return true;
  }

  public toggle(selected: boolean): void {
    if (this._params && (this._params.node.isSelected() ?? false) !== selected) {
      this._params.node.setSelected(selected);
    }
    this._syncFromNode();
  }
}
